<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">入驻信息修改</span>
      </div>
    </div>
    <div class="form">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="93px"
               style="position:relative;"
               class="demo-ruleForm">
        <el-form-item label="机构名称："
                      prop="name">
          <el-input v-model="ruleForm.name"
                    placeholder="基层卫生医疗机构请输入* 机构名称含省市"
                    style="width: 633px;"></el-input>
        </el-form-item>
        <el-form-item label="机构类型："
                      prop="type">

          <el-select v-model="ruleForm.type"
                     placeholder="请选择机构类型">
            <el-option v-for="item in OrgTypeOptions"
                       :key="item.id"
                       :label="item.valueText"
                       :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地域："
                      prop="region">
          <el-cascader v-model="ruleForm.region"
                       style="width: 633px;"
                       placeholder="请选择省市区县"
                       :options="arealist"
                       @expand-change="expandChange"></el-cascader>
          <span class="regionspan"
                v-show="!ruleForm.region||ruleForm.region==1"
                @click.stop>{{region}}</span>
        </el-form-item>
        <el-form-item label="封面图："
                      style="width:400px;margin-bottom:22px;"
                      prop="banar">
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="2"
                     :orgid="orgid"
                     :onSuccess="handleSuccess3"
                     class="addt4box">
            <div class="addmp4box"
                 v-show="!bansrc">
              <img src="../../../assets/img/icon/import.png"
                   alt="">
              <span>上传图片</span>
            </div>
            <img :src="bansrc"
                 v-show="bansrc"
                 class="banimg"
                 alt="">
          </webupload>
          <span style="position: absolute;top: 45px;left: 0px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;">支持扩展名：png、jpg、496*280像素</span>
        </el-form-item>
        <el-form-item label="授权书上传："
                      label-width="107px"
                      style="height:53px"
                      prop="certificate">
          <webupload fileaccept=".pdf"
                     :Maxfileszie="100"
                     :uploadtype="2"
                     :orgid="orgid"
                     :onSuccess="handleSuccess"
                     style="padding-bottom:-60px;float: left;">
            <div class="shouquanshu">
              <img src="../../../assets/img/icon/bianji2.png"
                   alt="">
              <span>{{ruleForm.pdfname}}</span>
            </div>
          </webupload>
          <div style="position:relative;top:0px;left:50px;font-size: 14px;color: #CC0000;display:flex;">
            <img src="../../../assets/img/shouquanshu.png"
                 alt=""
                 style="margin-right:10px;color: #333333;">
            <span>入驻机构店铺授权书模板</span>
          </div>
        </el-form-item>
        <el-form-item label="尺寸199*61像素"
                      label-width="130px"
                      style="position:absolute;top:110px;right:0px;"
                      prop="logoImg">
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="2"
                     :orgid="orgid"
                     :onSuccess="handleSuccess2"
                     :before-upload="beforeAvatarUpload"
                     style="width:133px;height:40px;;background: #0b868613;position:absolute;top:-70px;left:-135px;">
            <img v-if="ruleForm.logoImg"
                 :src="ruleForm.logoImg"
                 style="width:133px;height:40px"
                 class="avatar" />
            <i v-else
               style="color:#0B8586;font-size:30px;padding:5px 50px;"
               class="el-icon-plus avatar-uploader-icon"></i>
          </webupload>
          <span style="position:absolute;top:-21px;left:-90px;width:100px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">机构Logo</span>
        </el-form-item>
        <el-form-item>
          <div class="xzbtn"
               style="margin-left:180px"
               @click="submitForm">提交修改</div>
          <div class="xzbtn"
               style="margin-left:10px;background: #9EA2A2;"
               @click="quxiao">取消</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import webupload from '../../../components/webupload/webupload.vue';
export default {
  name: 'userVip',
  components: {
    webupload
  },
  data () {
    return {
      AuthorId: '',
      arealist: [],
      oldList: '',
      region: '',
      ruleForm: {
        name: '',
        type: '',
        region: '',
        logoImg: '',
        pdfname: '',
        logoImgId: '',
        certificateId: '',
        banid: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择机构类型', trigger: 'change' }
        ],
        region: [
          { required: true, message: '请选择省市区县', trigger: 'change' }
        ],
        logoImg: [
          { required: true, message: '' }
        ],
        certificate: [
          { required: true, message: '', trigger: 'blur' }
        ],
        banar: [{ required: true, message: '', trigger: 'blur' }]
      },
      orgid: 0,
      OrgTypeOptions: [],
      bansrc: ''
    };
  },
  created () {
    this.orgid = Number(this.$route.query.id)
    this.getarealist()
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    }
    this.GetOrgTypeList()
    this.GetMyStoreList()
  },
  methods: {
    GetMyStoreList () {
      this.httphelper.post('/api/CGPEnterPriseApi/GetPrgRecordContent', {
        id: this.orgid,
      })
        .then(res => {
          if (res.data.data) {
            this.oldList = res.data.data
            this.ruleForm.name = res.data.data.org_name
            this.ruleForm.type = res.data.data.org_type
            this.ruleForm.pdfname = res.data.data.res_Title
            this.ruleForm.logoImg = res.data.data.org_logourl
            this.ruleForm.region = 1
            this.ruleForm.logoImgId = res.data.data.org_logorId
            this.ruleForm.certificateId = res.data.data.authorrid
            this.bansrc = res.data.data.banner_url
            this.ruleForm.banid = res.data.data.banner_rid
            for (let a in areaList.province_list) {
              if (a == res.data.data.provinceCode) {
                this.region = areaList.province_list[a]
              }
            }
            for (let a in areaList.city_list) {
              if (a == res.data.data.cityCode) {
                this.region = this.region + ' / ' + areaList.city_list[a]
              }
            }
            for (let a in areaList.county_list) {
              if (a == res.data.data.districtCode) {
                this.region = this.region + ' / ' + areaList.county_list[a]
              }
            }
          }
        });
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    getarealist () {
      for (let a in areaList.province_list) {
        this.arealist.push({
          value: a,
          label: areaList.province_list[a],
          children: []
        })
      }
    },
    submitForm () {
      if (this.ruleForm.name == '') {
        this.$message.warning('机构名称不能为空');
        return
      } else if (this.ruleForm.type == '') {
        this.$message.warning('请选择机构类型');
        return
      } else if (this.ruleForm.region == '') {
        this.$message.warning('请选择省市区县');
        return
      } else if (this.ruleForm.logoImg == '') {
        this.$message.warning('请上传机构Logo');
        return
      } else if (this.ruleForm.certificate == '') {
        this.$message.warning('请上传授权书');
        return
      } else if (this.ruleForm.banid == '') {
        this.$message.warning('请上传封面图');
        return;
      }
      if (this.ruleForm.region == 1) {
        this.ruleForm.region = [this.oldList.provinceCode, this.oldList.cityCode, this.oldList.districtCode]
      }

      if (this.ruleForm.certificate == this.oldList.authorurl) {
        this.ruleForm.certificate = 5161
      }
      if (this.ruleForm.logoImg == this.oldList.org_logourl) {
        this.ruleForm.logoImg = 5161
      }
      this.httphelper.post('/api/CGPEnterPriseApi/OrgRegApply', {
        userId: Number(this.AuthorId),
        id: this.oldList.id,
        orgName: this.ruleForm.name,
        type: Number(this.ruleForm.type),
        provinceCode: this.ruleForm.region[0],
        cityCode: this.ruleForm.region[1],
        districtCode: this.ruleForm.region[2],
        logorid: Number(this.ruleForm.logoImgId),
        filerid: Number(this.ruleForm.certificateId),
        bannId: Number(this.ruleForm.banid)
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('入驻信息修改成功');
            this.$router.push({
              path: '/user/userOrgEnter'
            })
          } else if (res.data.code == 206) {
            this.$message.error('当前入驻申请已通过,无法修改');
          }
        });
    },
    quxiao () {
      this.$router.push({
        path: '/user/userOrgEnter'
      })
    },
    handleSuccess (response) {
      this.ishowmodel = true;
      this.ruleForm.certificate = response.ossfileurl
      this.ruleForm.certificateId = response.resid
      this.modelimgsrc = response.ossfileurl;
    },
    handleSuccess2 (response) {
      this.ishowmodel = true;
      this.ruleForm.logoImg = response.ossfileurl
      this.modelimgsrc = response.ossfileurl;
      this.ruleForm.logoImgId = response.resid
    },
    handleSuccess3 (response) {
      this.ruleForm.banid = response.resid;
      this.bansrc = response.ossfileurl;
    },
    expandChange (val) {
      if (val.length == 1) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            this.arealist[i].children = []
          }
        }
        for (let b in areaList.city_list) {
          if (b.substr(0, 2) == val[0].substr(0, 2)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                this.arealist[i].children.push({
                  value: b,
                  label: areaList.city_list[b],
                  children: []
                })
              }
            }
          }
        }
      } else if (val.length == 2) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            for (let a = 0; a < this.arealist[i].children.length; a++) {
              if (this.arealist[i].children[a].value == val[1]) {
                this.arealist[i].children[a].children = []
              }
            }
          }
        }
        for (let b in areaList.county_list) {
          if (b.substr(0, 4) == val[1].substr(0, 4)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                for (let a = 0; a < this.arealist[i].children.length; a++) {
                  this.arealist[i].children[a].children.push({
                    value: b,
                    label: areaList.county_list[b]
                  })
                }
              }
            }
          }
        }
      }
    },
    GetOrgTypeList () {
      this.httphelper
        .get('/api/BasicsmesApi/GetCodeResultList', {
          type: 5
        })
        .then(res => {
          if (res.code == 200) this.OrgTypeOptions = res.data
        });

    }
  }
};
</script>

<style scoped>
.xuzhi {
    border-bottom: 1px solid #e2e2e2;
    padding-bottom: 36px;
}
.xuzhi .xztitle {
    height: 18px;
    line-height: 18px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    border-left: 2px solid #0b8586;
    padding-left: 14px;
    margin-top: 38px;
    margin-bottom: 10px;
}
.xuzhi .xznr {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 34px;
    height: 160px;
    overflow-y: scroll;
    padding-right: 50px;
}
.xzbtn {
    margin-top: 12px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
}
.listtop {
    height: 80px;
    margin-top: 20px;
    display: flex;
    align-items: center;
}
.listtop img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    border-radius: 50%;
}
.listtop span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    width: 33.3%;
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    width: 33.3%;
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.form {
    padding-top: 30px;
}
.regionspan {
    color: #606266;
    font-size: inherit;
    background-color: #fff;
    position: absolute;
    height: 36px;
    line-height: 36px;
    left: 15px;
    top: 2px;
}
.shouquanshu {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    width: 333px;
    border-bottom: 1px solid #e5e5e5;
    height: 40px;
    display: flex;
    align-items: center;
}
.shouquanshu img {
    margin-right: 10px;
    margin-left: 10px;
}
.banimg {
    width: 96px;
    height: 54px;
}
.addt4box ::v-deep .el-upload--text {
    height: 54px;
}
.addt4box {
    height: 54px;
}
.addmp4box {
    width: 109px;
    height: 30px;
    border: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
    position: relative;
    top: 6px;
}
.addmp4box span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-left: 10px;
}
</style>

